import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import React from "react";
import { connect } from "react-redux";
import { closeDrawerMenu, paths } from "../../../actions/actionCreators";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import PersonIcon from "@material-ui/icons/Person";
import makeStyles from "@material-ui/core/styles/makeStyles";
import TocIcon from "@material-ui/icons/Toc";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import LogoutIcon from "@material-ui/icons/ExitToApp";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { push } from "connected-react-router";
import { LOGOUT } from "../../../actions/actionsTypes";
import i18n from "../../../i18nextInitiator";
import GameIcon from "@material-ui/icons/SportsEsports";
/**
 * Translation Function
 * @type {TFunction}
 */
const t = i18n.getFixedT("fa", "general");
/**
 * JSS
 * @type {(props?: any) => ClassNameMap<"root">}
 */
const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.primary.light,
    width: 250,
    "& .MuiListItemIcon-root": {
      color: theme.palette.primary.main,
    },
  },
}));
/**
 * Redux States.
 * @param state
 */
const mapStateToProps = (state) => ({ ...state.order });
/**
 * Redux Dispatchers.
 * @param dispatch
 * @returns {{logout: logout, goProfile, goOrderHistory, goFirstPage}}
 */
const mapDispatchToProps = (dispatch) => ({
  goProfile: () => dispatch(push(paths.profile)),
  goGame: () => dispatch(push(paths.game)),
  goOrderHistory: () => dispatch(push(paths.order_history)),
  goFirstPage: () => dispatch(push(paths.map)),
  logout: () => {
    dispatch({ type: LOGOUT });
    dispatch(push(paths.map));
  },
});
/**
 * Drawer Menu Component
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const DrawerMenu = (props) => {
  const classes = useStyles();
  const {
    location: { pathname },
  } = props;

  const handleClose = () => {
    closeDrawerMenu();
    props.logout();
  };

  return (
    <SwipeableDrawer
      classes={{ paper: classes.root }}
      anchor={"left"}
      onOpen={() => {}}
      open={props.openDrawerMenu}
      hysteresis={1}
      onClose={closeDrawerMenu}
    >
      <List component="nav" className={classes.list}>
        <ListItem
          button
          onClick={() => {
            props.goFirstPage();
            closeDrawerMenu();
          }}
          hidden={pathname === paths.map}
        >
          <ListItemIcon>
            <LocalShippingIcon />
          </ListItemIcon>
          <ListItemText primary={t("new-order")} />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            props.goOrderHistory();
            closeDrawerMenu();
          }}
          hidden={pathname === paths.order_history}
        >
          <ListItemIcon>
            <TocIcon />
          </ListItemIcon>
          <ListItemText primary={t("order-history")} />
        </ListItem>

        <Divider />

        {/* <ListItem button
                      onClick={()=>{
                          props.goGame()
                          closeDrawerMenu()
                      }}>
                <ListItemIcon>
                    <GameIcon/>
                </ListItemIcon>
                <ListItemText primary={t("nowrouz-game.menu-title")}/>
            </ListItem> */}

        <ListItem
          button
          onClick={() => {
            props.goProfile();
            closeDrawerMenu();
          }}
          hidden={pathname === paths.profile}
        >
          <ListItemIcon>
            <PersonIcon />
          </ListItemIcon>
          <ListItemText primary={t("profile")} />
        </ListItem>

        <ListItem button onClick={handleClose}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary={t("logout")} />
        </ListItem>
      </List>
    </SwipeableDrawer>
  );
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(DrawerMenu);
